var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"toggle-column-btn",class:{hidden: _vm.getColumnProperty(_vm.column.field, 'hide')},attrs:{"type":"button"},on:{"click":function($event){return _vm.toggleColumnVisibility(_vm.column.field)}}},[_vm._v(" "+_vm._s(_vm.column.headerName)+" "),_c('span',[_c('ico',{attrs:{"name":"icoDragHandle","color":"#CFD8DD"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }